import { useState, useEffect } from 'react';
import api from '../lib/api';

/**
 * Hook personnalisé pour charger les blocs d'une page
 * Utilisé par les pages thématiques pour afficher les blocs globaux
 * 
 * Usage:
 * const { blocks, loading, error } = usePageBlocks('page-precommandes');
 */
const usePageBlocks = (pageIdOrSlug) => {
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pageIdOrSlug) {
      setLoading(false);
      return;
    }

    const loadBlocks = async () => {
      try {
        setLoading(true);
        
        // Déterminer si c'est un ID ou un slug
        const isSlug = pageIdOrSlug.startsWith('/');
        let response;
        
        if (isSlug) {
          // Charger par slug
          response = await api.get(`/pages/slug${pageIdOrSlug}`);
        } else {
          // Charger par ID
          response = await api.get(`/pages/${pageIdOrSlug}`);
        }
        
        const pageData = response.data;
        
        // Filtrer uniquement les blocs actifs
        const activeBlocks = (pageData.blocks || []).filter(b => b.is_active);
        
        setBlocks(activeBlocks);
        setError(null);
      } catch (err) {
        console.error(`Erreur chargement blocs de page ${pageIdOrSlug}:`, err);
        setError(err.message || 'Erreur de chargement');
        setBlocks([]);
      } finally {
        setLoading(false);
      }
    };

    loadBlocks();
  }, [pageIdOrSlug]);

  return { blocks, loading, error };
};

export default usePageBlocks;
